import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { APP_HELPING_LEADS_ROUTE } from "./LeadsfromWebsite.path";

const LeadsfromWebsite = Loadable(
    lazy(() =>
        import("./LeadsfromWebsite").then(({ LeadsfromWebsite }) => ({
            default: LeadsfromWebsite,
        }))
    )
);


export const HelpingLeadsRoutes = [
    {
        path: APP_HELPING_LEADS_ROUTE,
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess
                moduleIds={[ALLOWED_MODULES.LEADS]}
            >
                <LeadsfromWebsite />
            </AuthorizedRoute>
        ),
    },
   
];
